import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-geography-lab',
  templateUrl: './geography-lab.component.html',
  styleUrls: ['./geography-lab.component.scss']
})
export class GeographyLabComponent implements OnInit {
  activeLightboxImage: string | null = null;

  geographyImages = [
    '/assets/img/facilities/imgi_333_geography_lab_img1-1200x800.jpg',
    '/assets/img/facilities/imgi_330_geography_lab_img2-1200x800.jpg',
    '/assets/img/facilities/imgi_327_geography_lab_img3-1200x800.jpg',
    '/assets/img/facilities/imgi_324_geography_lab_img4-1200x800.jpg',
    '/assets/img/facilities/imgi_321_geography_lab_img5-1200x800.jpg',
    '/assets/img/facilities/imgi_318_geography_lab_img6-1200x800.jpg'
  ];

  constructor() { }

  ngOnInit(): void { }

  openLightbox(src: string): void {
    this.activeLightboxImage = src;
  }

  closeLightbox(): void {
    this.activeLightboxImage = null;
  }
}

